
export class ClassifaiSetting {
    constructor(

        public directMode?: boolean,
        public state?: string,
        public onlyNewProducts?: boolean
    ) {
    }
}
